import { gql } from '@apollo/client';

export const REVIEW_ADDRESS_LOCATION_REVIEW = gql`
  mutation ReviewAddressLocationReview($input: AddressLocationReviewReviewInput!) {
    reviewAddressLocationReview(input: $input) {
      success
      code
      message
    }
  }
`;

export interface AddressLocationReviewReviewInput {
  id: string;
  reviewStatus: 'PENDING' | 'APPROVED' | 'REJECTED';
  approvedLatitude?: string | null;
  approvedLongitude?: string | null;
  approvedPrimaryTypeCode?: string | null;
  approvedSecondaryTypeCode?: string | null;
}

export interface AddressLocationReviewReviewResultType {
  success: boolean;
  code: string;
  message: string;
}

export interface ReviewAddressLocationReviewResponse {
  reviewAddressLocationReview: AddressLocationReviewReviewResultType;
}

